import { render, staticRenderFns } from "./CTitle.vue?vue&type=template&id=cf9d612c&scoped=true&"
import script from "./CTitle.vue?vue&type=script&lang=js&"
export * from "./CTitle.vue?vue&type=script&lang=js&"
import style0 from "./CTitle.vue?vue&type=style&index=0&id=cf9d612c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d612c",
  null
  
)

export default component.exports